// extracted by mini-css-extract-plugin
export default {"root":"work_root__AUwaZ","container":"work_container__TwFkl","slider":"work_slider__m4HQ4","workT":"work_workT__qebmw"};